var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rgpd-page", attrs: { id: "cms" } }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "cmsContent container" }, [
          _c("h1", [_vm._v("Politique de confidentialité")]),
          _vm._v(" "),
          _c("h2", [_vm._v("Nos engagements :")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Le présent engagement de confidentialité s’applique à la collecte et à l’exploitation des informations personnelles susceptibles d’être recueillies par CLYO Systems à chaque fois que vous êtes en contact avec notre société, c’est-à-dire lorsque vous visitez notre site Web, faites l’acquisition de produits et de services CLYO Systems ou contactez nos partenaires spécialisés dans le domaine commercial ou l’assistance technique."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Nous ne collectons que les données qui sont nécessaires au bon fonctionnement de notre service."
            ),
            _c("br"),
            _vm._v(
              "Vos données sont protégées au sein de serveurs sécurisés. "
            ),
            _c("br"),
            _vm._v(
              "Lorsque vos données ne sont plus utiles, elles sont supprimées. "
            ),
            _c("br"),
            _vm._v("Vous avez un droit de regard sur vos données."),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("Quelles données nous utilisons et pourquoi ?")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Nous collectons uniquement des données qui sont indispensables au bon fonctionnement de notre service et nécessaires à des fins de prospections commerciales. Nous ne collecterons jamais de données sans votre consentement."
            ),
          ]),
          _c("p"),
          _c("p", [
            _c("strong", [_vm._v("- Nom et coordonnées de nos clients")]),
            _c("br"),
            _vm._v(
              "                                                                                      \n\t\t\tPourquoi ? Nous avons besoin de ces données pour garantir notre service de livraison, de suivi technique et de maintenance, de mise à jour du logicielle et de la relation commerciale."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("- Vos informations de paiement")]),
            _c("br"),
            _vm._v(
              "\n\t\t\tPourquoi ? Nous avons besoin de ces données pour remplir notre part du contrat, et pour que vous puissiez également recevoir nos remboursements le cas échéant."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("- Informations de navigation (cookies), adresse IP"),
            ]),
            _c("br"),
            _vm._v(
              "                                                     \n\t\t\tPourquoi ?   À l’instar de nombreux autres, le site Web CLYO Systems utilise des “cookies” ainsi que d’autres technologies permettant d’identifier les sections de notre site les plus fréquentées, les destinations de nos visiteurs et la durée de leur visite. Ces études de trafic nous donnent les moyens d’enrichir encore davantage notre site et de mesurer l’efficacité des communications avec nos clients. Grâce à ces cookies et autres technologies, nous avons la certitude que nos publicités électroniques s’accompagnent de retombées commerciales pour nos produits et services. À noter également que les cookies s’avèrent précieux pour personnaliser vos interactions et vous offrir une commodité accrue à chaque fois que vous nous contactez."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Le simple fait de connaître votre prénom, par exemple, nous permet de personnaliser notre message d’accueil lors de votre prochaine visite sur CLYO Systems. De même, des informations telles que votre pays et votre langue ou l’établissement scolaire dans lequel vous professez, le cas échéant sont précieux pour vous guider utilement lors de vos emplettes en ligne. Vos coordonnées, les numéros de série de vos produits et les précisions concernant votre équipement informatique facilitent, pour leur part, l’enregistrement de vos produits, la personnalisation de votre système, la configuration de vos comptes Internet et ainsi que la fourniture de services.\n\t\t\tMalgré tout, si vous préférez que les cookies ne soient pas activés, consultez nous, nous vous exposeront étape par étape les modalités de désactivation. Veuillez noter que certaines fonctionnalités du site Web CLYO Systems ne seront pas disponibles une fois les cookies désactivés."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "À l’instar de la plupart des sites Web, nous collectons automatiquement certaines informations que nous stockons dans des fichiers journaux adresses IP, type de navigateur utilisé, fournisseur d’accès, pages d’origine et de destination, système d’exploitation, date/heure et séquence de navigation.\n\t\t\tNous nous servons de ces informations, non nominatives, pour analyser des tendances, administrer le site, assurer un suivi des opérations des utilisateurs à travers le site et obtenir des informations à caractère démographique sur notre base d’utilisateurs dans sa globalité. CLYO Systems s’interdit d’exploiter les informations ainsi recueillies pour démarcher directement l’utilisateur."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Certains de nos e-mails comportent un “lien direct vers URL” renvoyant à des contenus sur le site Web CLYO Systems. En cliquant sur l’une de ces URL, le client transite par notre serveur Web avant de parvenir à la page Web de destination. Par l’usage que vous réservez à ces liens, nous évaluons l’intérêt que vous portez à des rubriques particulières et mesurons l’efficacité de nos communications avec nos clients. Pour éviter d’être “pisté”, il vous suffit d’éviter de cliquer sur les liens de type texte ou graphique incorporés à nos e-mails."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\tNous utilisons également des “pixel tags” — petites images d’un pixel — qui nous renseignent sur les sections de notre site Web visitées par nos clients ou nous permettent de mesurer l’efficacité des recherches effectuées par ces derniers sur notre site."
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("Avec qui vos données sont partagées ?")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Vos données ne sont jamais partagées à des tiers afin qu’ils puissent les utiliser à leurs fins publicitaires."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\tToutefois, certaines de vos données sont partagées avec nos partenaires afin de nous permettre de vous fournir nos services :"
            ),
            _c("br"),
            _vm._v("\n\t\t\t- Les transporteurs"),
            _c("br"),
            _vm._v("\n\t\t\t- Les prestataires de paiement"),
            _c("br"),
            _vm._v(
              "\n\t\t\tTous ces prestataires n’ont accès qu’aux données dont ils ont besoin pour vous délivrer le meilleur service possible."
            ),
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v("Vos droits concernant vos données personnelles ?"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- Vous avez le droit d’être informé quant à l’utilisation qui est faite de vos données"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t- Vous avez le droit d’accéder à ces données pour les rectifier ou les supprimer"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t- Vous avez le droit de vous plaindre auprès de votre régulateur de protection des données (CNIL)"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Pour exercer vos droits, veuillez contacter notre service dédié à l’adresse suivante : \n\t\t\tCLYO SYSTEMS, 7 Impasse des Noisetiers, 06100 Nice"
            ),
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              "Combien de temps conservons-nous vos données et où sont-elles stockées ?"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Nous conservons vos informations pendant toute la durée nécessaire a la gestion de notre relation commerciale et jusqu’à 3 années maximum après avoir passé votre dernière commande ou avoir eu un dernier échange avec nos services."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Pour satisfaire aux obligations légales ou réglementaires, nous pouvons également conserver vos données même après que nous n’avons plus besoin de vous fournir des services."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\tVos données sont stockées dans nos bases de données ou celles de nos prestataires de services."
            ),
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              "Nos modalités de protection de vos informations personnelles"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "CLYO Systems prend de multiples précautions, y compris des mesures administratives, techniques et physiques, pour protéger vos informations personnelles contre les risques de perte, de vol et d’emploi abusif, ainsi que contre tout accès non autorisé, divulgation, modification et destruction."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sur toutes les pages Web requérant la saisie d’informations personnelles, CLYO Systems ainsi que certains de ses revendeurs, utilisent le codage SSL (Secure Sockets Layer). Pour y effectuer des achats, servez-vous d’un navigateur compatible SSL tel que Safari, Netscape Navigator version 3.0 ou ultérieure ou Internet Explorer. Vos informations personnelles et le numéro de votre carte bancaire seront ainsi transmis sur Internet en toute confidentialité."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\tN’hésitez pas à observer vous-même certaines précautions pour protéger vos données personnelles lorsque vous êtes sur Internet. Changez fréquemment de mot de passe, en préférant des caractères alphanumériques, et assurez-vous que vous faites appel à un navigateur Web sécurisé tel que Safari."
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("Notre communication")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Nous pouvons envoyer des emails pour vous tenir informé en permanence de l’actualité de nos produits, des mises à jour de logiciels, de nos offres spéciales et vous faire part des événements jugés utiles."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Si vous ne souhaitez pas que CLYO Systems vous informe sur son actualité, les mises à jour de ses logiciels et ses produits et services, spécifiez-le sur www.clyosystems.com/contact/myinfo et actualisez vos coordonnées et préférences en conséquence."
            ),
          ]),
          _vm._v(" "),
          _c("time", { attrs: { datetime: "2018-05-25 20:00" } }, [
            _vm._v("Mis à jour le 25 mai 2018"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }